import { reducers } from '@wix/da-shared-react/pkg/redux/shared';
import profileHeroEditor from './profileHeroEditor';
import profileOwner from './profileOwner';
import sections from './sections';
import gallectionSection from './gallectionSection';
import layout from './layout';
import modules from './modules';
import statsSection from './statsSection';

const DEFAULT_ENVIRONMENT = {};

const rootReducers = {
  ...reducers,
  profileHeroEditor,
  profileOwner,
  sections,
  gallectionSection,
  environment: state => state || DEFAULT_ENVIRONMENT,
  layout,
  modules,
  statsSection,
};

export default rootReducers;
